import { createContext, useContext, useEffect, useState, ReactNode } from 'react';
import * as AuthAPI from '../api/auth';

interface AuthCtx {
  user: AuthAPI.UserInfo | null;
  loading: boolean;
  login: (usuario: string, senha: string) => Promise<void>;
  logout: () => Promise<void>;
  refresh: () => Promise<void>;
}

const AuthContext = createContext<AuthCtx | null>(null);

export function AuthProvider({ children }: { children: ReactNode }) {
  const [user, setUser] = useState<AuthAPI.UserInfo | null>(null);
  const [loading, setLoading] = useState(true);

  async function refresh() {
    try {
      const u = await AuthAPI.me();
      setUser(u);
    } catch {
      setUser(null);
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    refresh();
  }, []);

  async function doLogin(usuario: string, senha: string) {
    const u = await AuthAPI.login(usuario, senha);
    setUser(u);
  }

  async function doLogout() {
    try {
      await AuthAPI.logout();
    } finally {
      setUser(null);
    }
  }

  return (
    <AuthContext.Provider value={{ user, loading, login: doLogin, logout: doLogout, refresh }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error('useAuth deve estar dentro de AuthProvider');
  return ctx;
}
